/* styles/models/tabulator.css.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.panel_models_markup_HTML = "bk-panel-models-markup-HTML";
    exports.default = `.tabulator-table{max-width:max-content;}.tabulator-table .tabulator-row .row-content .bk-panel-models-markup-HTML{white-space:normal;}`;
}
